import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { DataService } from '../../../services/data.service';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { PackageEngineerDTO } from './../../../models/internal/package-engineer-dto';
/* 
  TMS-32170 Create new screen, setup component and menu to add package engineers in the system 
  Restricted to PackageEngineer_Admin role only 
*/
@Component({
  selector: 'app-pe-addpackageengineer',
  templateUrl: './pe-addpackageengineer.component.html',
  styleUrls: ['./pe-addpackageengineer.component.scss']
})
export class PeAddpackageengineerComponent implements OnInit {

  searchUserInfoUrl: string;
  addPackageEngineerForm: FormGroup;
  @Output() formUpdated = new EventEmitter<number>();
  @ViewChild('SearchUserAutoComplete') SearchUserAutoComplete: TeslaAutocompleteComponent;

  public formErrorsAddPackageEngineer = {
    FullName: '',
  };

  constructor(private dataService: DataService,
    private fb: FormBuilder,
    localstorageService: LocalstorageService,
    private toastService: ToastService,
    private formService: FormService,
    appSettings: AppSettings,
    logger: NGXLogger) {

    this.addPackageEngineerForm = this.fb.group({
      FullName: [
        null,
        Validators.compose([
          Validators.required
        ]),
      ],
    })
    this.searchUserInfoUrl = appSettings.Packaging2APIUrl + '/externaldata/GetUserDetailsByName';
  }

  ngOnInit() {
    this.addPackageEngineerForm.valueChanges.subscribe(data => {
      this.formErrorsAddPackageEngineer = this.formService.validateForm(
        this.addPackageEngineerForm,
        this.formErrorsAddPackageEngineer,
        true
      );
      this.formUpdated.emit();
    });
  }

  getEngineerUserId() {
    return this.addPackageEngineerForm.controls['FullName'].value;
  }

  //call api to save/update package engineer information  
  AddPackageEngineerInfo() {
    const packageengineerDTO: PackageEngineerDTO = new PackageEngineerDTO();
    packageengineerDTO.EngineerUserId = this.getEngineerUserId();
    this.dataService
      .addPackageEngineerInfo(packageengineerDTO)
      .subscribe((response: any) => {
        if (response != null && response.Success) {
          this.toastService.success('Package engineer saved successfully', true);
        }
      });

    this.addPackageEngineerForm.reset();
  }


  onEmptyUserInfo(eventObj: any): void {
    this.SearchUserAutoComplete.list = [];

  }




}
